import React from "react";
import Navbar from "../Components/Navbar";
import Home from "../Components/Home/homepage";
import Footer from "../Components/Footer";

const Homepage = () => {
  return (
    <div>
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
};

export default Homepage;
